'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002450 from "./presto.-Two-Factor-Auth-View$$anon$50.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002452 from "./presto.-Two-Factor-Auth-View$$anon$52.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002454 from "./presto.-Two-Factor-Auth-View$$anon$54.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002456 from "./presto.-Two-Factor-Auth-View$$anon$56.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$49() {
  this.bES = null;
  this.bEK = null;
  this.bEL = false;
  this.bET = null;
  this.bEU = false;
  this.bEX = null;
  this.bEQ = null;
  this.bER = false;
  this.bEM = null;
  this.bEN = false;
  this.bEO = null;
  this.bEP = false;
  this.bEV = false;
  this.bEW = false;
  this.bES = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bEX = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$49 as $c_Lpresto_TwoFactorAuthView$$anon$49 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$49.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$49;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$49() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$49 as $h_Lpresto_TwoFactorAuthView$$anon$49 };
$h_Lpresto_TwoFactorAuthView$$anon$49.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bES;
});
$p.M = (function() {
  if ((!this.bEL)) {
    this.bEK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bEL = true;
  }
  return this.bEK;
});
$p.O = (function() {
  if ((!this.bEU)) {
    this.bET = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bEU = true;
  }
  return this.bET;
});
$p.D = (function() {
  return this.bEX;
});
$p.t = (function() {
  if ((!this.bER)) {
    this.bEQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bER = true;
  }
  return this.bEQ;
});
$p.N = (function() {
  if ((!this.bEN)) {
    this.bEM = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002450.$c_Lpresto_TwoFactorAuthView$$anon$50(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002452.$c_Lpresto_TwoFactorAuthView$$anon$52())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002454.$c_Lpresto_TwoFactorAuthView$$anon$54())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bEN = true;
  }
  return this.bEM;
});
$p.Q = (function() {
  if ((!this.bEP)) {
    this.bEO = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002456.$c_Lpresto_TwoFactorAuthView$$anon$56();
    this.bEP = true;
  }
  return this.bEO;
});
$p.v = (function() {
  if ((!this.bEW)) {
    this.bEV = false;
    this.bEW = true;
  }
  return this.bEV;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee562) => ((p) => \u03b4scrutinee562.zl(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$49 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$49, "presto.TwoFactorAuthView$$anon$49", ({
  SU: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$49 as $d_Lpresto_TwoFactorAuthView$$anon$49 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$49.js.map
